import React from 'react';
import PropTypes from 'prop-types';

import './ArrowPoint.scss';

function ArrowPoint({direction, arrowKey, isActive, onClick}) {
  console.log('render ArrowPoint');
  return (
    <span
      key={arrowKey}
      className={`icon-arrow icon-arrow-${direction} ${isActive ? 'active' : ''}`}
      onClick={(evt) => onClick(evt)}
      role="presentation"
    />
  );
}

ArrowPoint.propTypes = {
  arrowKey: PropTypes.string.isRequired,
  direction: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  onClick: PropTypes.bool,
};
ArrowPoint.defaultProps = {
  onClick: () => {},
};
function areEqual(prevProps, nextProps) {
  return prevProps.isActive === nextProps.isActive;
}

export default React.memo(ArrowPoint, areEqual);
